export function ProjectCard({ project, onSelect }) {
  return (
    <article
      className="project-card project-card--immersive glass-panel"
      onClick={() => onSelect(project)}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => event.key === 'Enter' && onSelect(project)}
    >
      <div className={`project-card__visual project-card__visual--${project.theme}`}>
        <img className="project-card__image" src={project.image} alt={project.imageAlt || project.title} loading="lazy" />
        <div className="project-card__badge-wrap">
          <span className="project-card__badge">{project.imageLabel}</span>
        </div>
      </div>
      <div className="project-card__body">
        <p className="eyebrow">{project.category}</p>
        <h3>{project.title}</h3>
        <p>{project.summary}</p>
        <div className="tag-row">
          {project.stack.map((item) => (
            <span className="tag" key={item}>
              {item}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}
